var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-home" }, [
      _c("p", { staticClass: "text-center" }, [_vm._v("خانه")]),
      _c("p", { staticClass: "text-center" }, [_vm._v("در حال تکمیل")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }